import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';
import Files from './Files';

const Guides = () => <Files title={<FormattedMessage {...globalMessages.guides} />} global />;

export default Guides;
